import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../types';
import { ILiveChatChangeMode } from '../../../common/messageCreators';
import { MessageItem } from '../MessageItem';
import { Line } from './Line';

export const ModeMessage: FC<ILiveChatChangeMode> = (props) => {
  const { t } = useTranslation();
  const { id, isLiveChat, overwriteWithKey, isTransferred } = props;
  const translateKey: TLocalesKeys =
    (overwriteWithKey as TLocalesKeys) ||
    (isLiveChat ? 'live_chat_start' : isTransferred ? 'chat_transferred_ended' : 'live_chat_end');
  return (
    <MessageItem width="full" id={id} dataHook="mode-message">
      <Line>{t(translateKey)}</Line>
    </MessageItem>
  );
};
